module.exports = __webpack_public_path__ + "media/美人技术.f057c669.mp3";